module.exports = __webpack_public_path__ + "static/img/30013 (2).271c0cc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30013 (2).webp
// module id = WMfV
// module chunks = 14